import styled from 'styled-components';
import { HighlightIcon } from 'takeat-design-system-ui-kit';

export const Container = styled.div`
  width: auto;
  height: auto;
  display: flex;
  flex-direction: column;
`;

export const DeliveryPrice = styled.div`
  padding-top: 15px;
  margin-top: 10px;
  border-top: solid #cdcdcd 1px;
  padding-bottom: 10px;
  width: 110mm;
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    span {
      font-size: 16px;
      font-weight: bold;
    }
  }
`;

export const Table = styled.div`
  padding-top: 10px;
  width: 110mm;
  text-align: center;
  font-size: 20px;
  margin-right: auto;
`;

export const Order = styled.div`
  width: 110mm;
  text-align: center;
  font-size: 15px;
  margin-right: auto;
  padding-bottom: 5px;
`;

export const Restaurant = styled.div`
  padding-top: 10px;
  width: 110mm;
  text-align: center;
  font-size: 20px;
  margin-right: auto;
  padding-bottom: 15px;
  border-bottom: solid black 1px;
`;

export const Body = styled.div`
  width: 110mm;
  clear: both;
`;

export const Phone = styled.div`
  text-align: left;

  font-size: 15px;
  padding-top: 10px;
  float: left;
`;

export const Time = styled.div`
  text-align: right;
  padding-right: 5px;
  font-size: 15px;
  padding-top: 10px;
  float: right;
`;

export const Items = styled.div`
  width: 110mm;
  padding-top: 20px;
`;

export const Item = styled.div`
  padding-top: 5px;
`;

export const ItemName = styled.div`
  font-size: 15px;
`;

export const ComplementsTitle = styled.div`
  font-size: 13px;
`;

export const Complements = styled.div`
  font-size: 12px;
  padding-left: 15px;
`;

export const ComplementsThirdLevel = styled.div`
  font-size: 12px;
  padding-left: 20px;
`;

export const Obs = styled.div`
  font-size: 13px;
`;

export const DeliveryInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 4px;

  span {
    font-size: 15px;
  }
`;

export const MotoboyDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ValuesAdvance = styled.span`
  color: #3d3d3d;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: normal !important;
  line-height: 182%; /* 29.12px */
  align-self: stretch;
`;

export const ContainerValueAdvance = styled.div`
  display: flex;
  margin-bottom: 0;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;
  gap: 4px;
`;

export const OverlayAdvance = styled.div`
  position: fixed;
  top: 0;
  margin-bottom: 0 !important;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px); /* DESFOQUE */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2147483647;
`;

export const ContainerAdvance = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0 !important;
`;

export const ContainerDeleteAdvance = styled.div`
  display: flex;
  margin-bottom: 0 !important;
  padding: 16px 16px 8px 16px;
  align-items: flex-start;
  gap: 16px;
  border-radius: 12px 12px 0 0;
  background: var(--Takeat-Colors-Neutrals-White, #fff);
`;

export const TextDeleteAdvance = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);

  /* Title/Title Medium/Semibold | 600 */
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 133.333% */
  letter-spacing: var(--Headline-Small-Tracking, 0);
`;

export const TextOrderAdvance = styled.span`
  color: ${({ $color }) => ($color ? '#C8131B' : '#222222')};

  /* Label/Label Large/Bold | 700 */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: ${({ $props }) => ($props ? 'normal' : '700')} !important;
  margin: ${({ $payment }) => ($payment ? '5px 0' : '')};
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.1px;
`;

export const ContainerFooterAdvance = styled.div`
  display: flex;
  margin-bottom: 0 !important;
  justify-content: space-between;
  padding: 16px 16px 8px 16px;
  align-items: flex-start;
  gap: 16px;
  border-radius: 0 0 12px 12px;
  background: var(--Takeat-Colors-Neutrals-White, #fff);
`;

export const ContainerInfoAdvance = styled.div`
  display: flex;
  margin-bottom: 0 !important;
  flex-direction: column;
  gap: 10px;
`;

export const ContainerAdvanceInfoPayment = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0 !important;
  gap: 5px;
`;

export const HighlightIconFixed = styled(HighlightIcon)`
  margin-bottom: 0 !important;

  div {
    margin-bottom: 0 !important;
  }
`;
